import { isAndroid, isIOS, isSafari } from 'react-device-detect';
import { ELoginMethods, ELoginMode, ESessionStorageKeys } from 'constants/enums';
import { EventSharedProps } from 'constants/apiRequest.types';
import { webStorageUtil } from 'state/webStorage.state.service';

const isWebviewBrowser = (): boolean => {
  const userAgent = navigator.userAgent.toLowerCase();
  return (
    userAgent.indexOf('instagram') > -1 ||
    userAgent.indexOf('fban') > -1 ||
    userAgent.indexOf('fbav') > -1 ||
    userAgent.indexOf('fb_iab') > -1 ||
    userAgent.indexOf('messenger') > -1
  );
};

const checkIfOlderOsVersions = (): boolean => {
  const ua = navigator?.userAgent?.toLowerCase();
  if (!ua) return true;

  const isChromeIOS = /crios/.test(ua);

  let versionMatch = ua.match(/version\/(\d+(\.\d+)?)/);

  if (!versionMatch) {
    versionMatch = ua.match(/crios\/(\d+(\.\d+)?)/); // Find version for Chrome
  }

  if (!versionMatch) return false; // Unable to extract version, consider it older

  const osMobileVersion = parseFloat(versionMatch[1]);
  if (isNaN(osMobileVersion)) return true; // Parsing failed, consider it older

  const SAFARI_IOS_THRESHOLD = 14.5;
  const CHROME_IOS_THRESHOLD = 92.1;
  const ANDROID_THRESHOLD = 123;

  return (
    ((isSafari || isIOS) && osMobileVersion < SAFARI_IOS_THRESHOLD) ||
    (isAndroid && osMobileVersion < ANDROID_THRESHOLD) ||
    (isChromeIOS && osMobileVersion < CHROME_IOS_THRESHOLD)
  );
};

const getLoginEventsData = ({
  eventSharedProps,
  method,
  options,
}: {
  eventSharedProps: EventSharedProps;
  method?: ELoginMethods;
  options?: Record<string, string>;
}) => {
  return {
    timestamp: eventSharedProps.timestamp,
    sessionId: eventSharedProps.sessionId,
    session_id: eventSharedProps.sessionId,
    publisher_id: eventSharedProps.publisherId,
    device_manufacture: eventSharedProps.deviceManufacturer,
    device_model: eventSharedProps.deviceModel,
    os: eventSharedProps.os,
    os_version: eventSharedProps.osVersion,
    browser: eventSharedProps.browser,
    browser_version: eventSharedProps.browserVersion,
    platform: eventSharedProps.platform,
    method,
    city: null,
    country: null,
    language: eventSharedProps.language,
    store_version: eventSharedProps.storeVersion,
    shared_ui_version: eventSharedProps.sharedUiVersion,
    utm_source: eventSharedProps.utm_source ?? null,
    utm_campaign: eventSharedProps.utm_campaign ?? null,
    utm_medium: eventSharedProps.utm_medium ?? null,
    utm_term: eventSharedProps.utm_term ?? null,
    utm_content: eventSharedProps.utm_content ?? null,
    source: webStorageUtil.get(ESessionStorageKeys.SOURCE) || 'browser app',
    ...options,
  };
};

const mapLoginModeToLoginMethod: Record<ELoginMode, ELoginMethods> = {
  [ELoginMode.USERNAME]: ELoginMethods.USERNAME,
  [ELoginMode.TOKEN_ID]: ELoginMethods.TOKEN,
  [ELoginMode.OTP]: ELoginMethods.OTP,
  [ELoginMode.PROVIDERS]: ELoginMethods.GOOGLE,
};

export const loginPageService = {
  isWebviewBrowser,
  checkIfOlderOsVersions,
  getLoginEventsData,
  mapLoginModeToLoginMethod,
};
